module.exports = "/_next/static/public/images/chrome-113c7a85460ce6a507616c55dd8f2c7c.svg";